import React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { getAttendanceToday } from "../../../../redux/overview/overviewState";
import AttendanceSummaryCard from "./AttendanceSummaryCard";
import AttendanceStatusCard from "./AttendanceStatusCard";
import dayjs from "dayjs";
import {
  CircleCheck,
  CircleAlert,
  LucideCircleX,
  LucidePlaneTakeoff,
} from "lucide-react";

const DailyAttendances = ({ recordList, doSearch, selectedDay }) => {
 
    useEffect(() => {
      if (!selectedDay) return;

      const date = selectedDay.format("YYYY-MM-DD");

      doSearch({
        start_date: date,
        end_date: date,
      });
    }, [selectedDay, doSearch]);



  const { overview = [], totals = {} } = recordList;

  const {
    total_present_days = 0,
    total_absent_days = 0,
    total_late_days = 0,
    total_on_leave = 0,
  } = totals;

  const presentEmployees = overview
    .filter(emp => emp.present_days > 0)
    .map(emp => ({
      name: emp.employee_name,
      role: emp.emp_role, 
      time: dayjs(emp.timed_in).format("HH:mm A"),
    }));
 
  const lateEmployees = overview
    .filter(emp => emp.late_days > 0)
    .map(emp => ({
      name: emp.employee_name,
      role: emp.emp_role,
      time: dayjs(emp.timed_in).format("HH:mm A"),
    }));

  const absentEmployees = overview
    .filter(emp => emp.absent_days > 0)
    .map(emp => ({
      name: emp.employee_name,
      role: emp.emp_role,
    }));

  const onLeaveEmployees = overview
    .filter((emp) => emp.on_leave > 0)
    .map((emp) => ({
      name: emp.employee_name,
      role: emp.emp_role,
    }));

    const attendanceData = [
    {
      type: "Present",
      count: total_present_days,
      employees: presentEmployees,
      icon: CircleCheck,
      color: "green",
    },
    {
      type: "Late",
      count: total_late_days,
      employees: lateEmployees,
      icon: CircleAlert,
      color: "amber",
    },
    {
      type: "Absent",
      count: total_absent_days,
      employees: absentEmployees,
      icon: LucideCircleX,
      color: "red",
    },
    {
      type: "On Leave",
      count: total_on_leave,
      employees: onLeaveEmployees,
      icon: LucidePlaneTakeoff,
      color: "blue",
    },
  ];

  const data = attendanceData;
  console.log(attendanceData);
  return (
    <div className="grid w-full gap-4 border rounded-lg shadow-lg p-6">
      <div className="flex flex-col text-left">
        <h2 className="label-gradient emerald text-[20px] font-semibold">
          Attendance Overview 
        </h2>
        <p>{selectedDay.format("dddd, MMMM D, YYYY")}</p>
      </div>


      <div className="grid grid-cols-4 gap-4">
        {attendanceData.map((item) => (
          <AttendanceSummaryCard
            key={item.type}
            type={item.type}
            count={item.count}
            icon={item.icon}
          />
        ))}
      </div>

      {attendanceData.map((item) => (
        <div key={item.type} className="mt-4">
          <div className="flex items-center gap-2 mb-2">
            <item.icon size={20} className={`text-${item.color}-600`} />
            <span className="font-semibold text-[16px]">
              {item.type} ({item.count})
            </span>
          </div>
          <AttendanceStatusCard employees={item.employees} statusType={item.type} />
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.overview.dailyAttendanceRecord?.data || { overview: [], totals: {} },
  requesting: state.overview.dailyAttendanceRecord?.requesting,
  error: state.overview.dailyAttendanceRecord?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getAttendanceToday(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DailyAttendances);
